import { object, string, number, array ,date, InferType } from 'yup';

const QuickAddScheme = object({
    name: string().required(),
    supplier: string().required()
})

export default QuickAddScheme